import React from "react";

const SectionItemContent = ({ content }) => {
  return <div className="">{content}</div>;
};

export default SectionItemContent;
